// extracted by mini-css-extract-plugin
var _1 = "pS5uXfPSB2fTKfYTioFe";
var _2 = "nQnpewB0050Cwzx1Gc6P";
var _3 = "J8VmVHZVtjuLrP5antNh";
var _4 = "ndkiAi1AKlZq1vvI2o_L";
var _5 = "XKx2EwGPhZWKl7372vdk";
var _6 = "QfK_h2sFsjCIexsDW9pY";
var _7 = "#000000";
var _8 = "#76F366";
var _9 = "#EB8632";
var _a = "#ECC834";
var _b = "#21FC87";
var _c = "#EA4A30";
var _d = "#C7EA45";
var _e = "#272B2B";
var _f = "#BDBDBD";
var _10 = "#7D7D7D";
var _11 = "#6A0DAD";
var _12 = "#3A65FF";
var _13 = "#4A90E2";
var _14 = "#ffffff";
var _15 = "uci41I1zzrHB9JHErLmz";
var _16 = "GX60fs2LEdLmfZlIg7Ll";
var _17 = "pcv4WzMPvE2fde3rVVGX";
var _18 = "VsiRJOdXSTANcpUShLHO";
var _19 = "VqkVKbw9yUqo1udcSqS5";
var _1a = "IhyCDDSTo5L44MOxUhVw";
var _1b = "1200px";
var _1c = "992px";
var _1d = "1366px";
var _1e = "768px";
var _1f = "1475px";
var _20 = "576px";
var _21 = "1600px";
var _22 = "320px";
var _23 = "2500px";
var _24 = "ecjewtuSoafCaLAAsKU8";
export { _1 as "accessForm", _2 as "accessFormContent", _3 as "accessFormHeader", _4 as "accessFormHeading", _5 as "active-media-preview", _6 as "base-link", _7 as "colorBlack", _8 as "colorGradeEX", _9 as "colorGradeFR", _a as "colorGradeGD", _b as "colorGradeOU", _c as "colorGradePR", _d as "colorGradeVG", _e as "colorNeutral", _f as "colorNeutralLighest", _10 as "colorNeutralLight", _11 as "colorNonOwnerSweetLine", _12 as "colorOwnerSweetLine", _13 as "colorRegularLinks", _14 as "colorWhite", _15 as "dataAccessFormGroup", _16 as "dataAccessSelection", _17 as "description", _18 as "label", _19 as "requiredMark", _1a as "reset-button", _1b as "screenlg", _1c as "screenmd", _1d as "screenml", _1e as "screensm", _1f as "screenxlg", _20 as "screenxs", _21 as "screenxxlg", _22 as "screenxxs", _23 as "screenxxxlg", _24 as "single-page-responsive-font-size" }
export default { "accessForm": _1, "accessFormContent": _2, "accessFormHeader": _3, "accessFormHeading": _4, "active-media-preview": _5, "base-link": _6, "colorBlack": _7, "colorGradeEX": _8, "colorGradeFR": _9, "colorGradeGD": _a, "colorGradeOU": _b, "colorGradePR": _c, "colorGradeVG": _d, "colorNeutral": _e, "colorNeutralLighest": _f, "colorNeutralLight": _10, "colorNonOwnerSweetLine": _11, "colorOwnerSweetLine": _12, "colorRegularLinks": _13, "colorWhite": _14, "dataAccessFormGroup": _15, "dataAccessSelection": _16, "description": _17, "label": _18, "requiredMark": _19, "reset-button": _1a, "screenlg": _1b, "screenmd": _1c, "screenml": _1d, "screensm": _1e, "screenxlg": _1f, "screenxs": _20, "screenxxlg": _21, "screenxxs": _22, "screenxxxlg": _23, "single-page-responsive-font-size": _24 }
